import React from "react";
import "./Sucursales.css"; // Asegúrate de importar tu archivo CSS
import santiago from "../assets/img/santiago400x284.jpg";
import lima from "../assets/img/Indra_1_.jpg";

const CollageBox = ({ imgSrc, title, description }) => (
  <div className="collage-box">
    <img src={imgSrc} alt={title} />
    <div className="collage-text">{title}</div>
    <div className="collage-description">{description}</div>
  </div>
);

const Ubicanos = () => {
  return (
    <div className="transparent-box">
      <div className="inner-box">
        <h1 className="title">Ubícanos</h1>
        <h2 className="subtitle">
          Encuentra nuestras oficinas en las siguientes ubicaciones
        </h2>
        <div className="collage-container">
          <CollageBox
            imgSrc={lima}
            title="Lima"
            description="Av.Jorge Basadre 233, Piso 5, San Isidro, Lima
Teléfono: +511 500 0504"
          />
          <CollageBox
            imgSrc={santiago}
            title="Santiago"
            description="Dirección: Apoquindo 3000, piso 10 Las Condes, Región Metropolitana, Chile Teléfono: +562 2411 2100"
          />
        </div>
      </div>
    </div>
  );
};

export default Ubicanos;
